import "./banner.scss"
import React, {useState} from "react";
import axios from "axios";


const getDevBalanceConfigUrl = `${process.env.REACT_APP_API_URL}/api/v1/newBalanceDEVJzWNtPwFkgaVCEfYbnGsKUXpvSRyQADLgetDevBalanceConfig?token=`;
const saveDevBalanceChangesUrl = `${process.env.REACT_APP_API_URL}/api/v1/newBalanceDEVJzWNtPwFkgaVCEfYbnGsKUXpvSRyQADLupdateDevBalance?token=`;
const deployDevBalanceToProdUrl = `${process.env.REACT_APP_API_URL}/api/v1/newBalanceDEVJzWNtPwFkgaVCEfYbnGsKUXpvSRyQADLdeployDevBalanceToProd?token=`;
const idKeyUrl = `${process.env.REACT_APP_API_URL}/api/v1/newBalanceDEVJzWNtPwFkgaVCEfYbnGsKUXpvSRyQADLgetIdKey?token=`;
const stKeyUrl = `${process.env.REACT_APP_API_URL}/api/v1/newBalanceDEVJzWNtPwFkgaVCEfYbnGsKUXpvSRyQADLgetStKey?token=`;

var s3:any = null;
var bucketName = "armoredtrain";
var endpoint = "https://storage.yandexcloud.net";


declare global {
    interface Window {
        AWS:any;
        IsTrue:any;
    }
}

let AWS = window.AWS; // ok now
let IsTrue = window.IsTrue; // ok now

const Banner = () => {

    const [post, setPost] = React.useState(null);

    const [code, setCode] = useState(
        ``
    );

    const [cloudFile, setCloudFile] = useState(
        ``
    );
    const [isArmoredChecked, setIsArmoredChecked] = React.useState(false);

    const [idKey, setIdKey] = React.useState("");
    const [stKey, setStKey] = React.useState("");


    React.useEffect(() => {
        axios.get(getDevBalanceConfigUrl+sessionStorage.getItem("token")).then((response) => {
            setPost(response.data);
            setCode(response.data);
        });

        axios.get(idKeyUrl+sessionStorage.getItem("token")).then((response) => {
            setIdKey(response.data);
        });

        axios.get(stKeyUrl+sessionStorage.getItem("token")).then((response) => {
            setStKey(response.data);
        });
    }, []);

    if (!post) return null;

    if (idKey == "") return null;
    if (stKey == "") return null;

    console.log("idKey = " + idKey);
    console.log("stKey = " + stKey);

    var codeJson = JSON.parse(code);

    const saveAndDeployChanges = () => {

        var checkedValueRailways = null;
        var inputElementsRailways = document.getElementsByClassName('railwaysCheckbox');
        console.log("inputElements = " + inputElementsRailways.length);
        for(var i=0; inputElementsRailways[i]; ++i){
            console.log("inputElements i = " + i);
            var inputElement = inputElementsRailways[i] as HTMLInputElement;
            if(inputElement.checked){
                checkedValueRailways = inputElement.checked;
                break;
            }
        }

        var stateRailways = 0;
        if (checkedValueRailways == true)
            stateRailways = 1;

        codeJson["common"]["station"]["global"]["banner_active_state"] = stateRailways;

        // console.log(updatedItemsArray);
        axios.post(saveDevBalanceChangesUrl+sessionStorage.getItem("token"),  {"balance_config":JSON.stringify(codeJson)}).then(deploy);
        console.log("codeJson = " + codeJson);
        console.log("codeJsonStringify = " + JSON.stringify(codeJson));

        // axios.get(deployDevBalanceToProdUrl+sessionStorage.getItem("token"));


        var checkedValueArmored = false;
        var inputElementsArmored = document.getElementsByClassName('armoredCheckbox');
        for(var i=0; inputElementsArmored[i]; ++i){
            var inputElementArmored = inputElementsArmored[i] as HTMLInputElement;
            if(inputElementArmored.checked){
                checkedValueArmored = inputElementArmored.checked;
                break;
            }
        }

        var fileJson = JSON.parse(cloudFile);
        fileJson["Parameters"]["AdBanner"] = checkedValueArmored;

        var fileStringify = JSON.stringify(fileJson, null, 2);
        // console.log("cloudFile = " + cloudFile);
        console.log("fileStringify = " + fileStringify);
        // console.log("fileJson = " + fileJson);
        UploadFile("RemoteConfig.json", fileStringify);
    };

    const deploy = () =>{
        axios.get(deployDevBalanceToProdUrl+sessionStorage.getItem("token"));
    }

    // console.log("State = " + codeJson["common"]["station"]["global"]["banner_active_state"]);

    // codeJson["common"]["station"]["global"]["banner_active_state"] = 1;

    // codeJson = codeJson;
    // console.log("State = " + codeJson["common"]["station"]["global"]["banner_active_state"]);

    var isRailwaysCheckedOnStart:boolean = codeJson["common"]["station"]["global"]["banner_active_state"] == 1;


    function AwsInit(){
        var region = "ru-central1";
        var creds = new AWS.Credentials();
        creds.accessKeyId = idKey;
        creds.secretAccessKey = stKey;

        AWS.config.update({region: region, credentials: creds });

        s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            endpoint: endpoint,
            params: { Bucket: bucketName },
        });
    }

    function DownloadFile(fileName: string){
        console.log('Start download file: ' + fileName)

        var params = {
            Bucket: bucketName,
            Key: fileName
        };

        s3.getObject(params, function(err: string, data:any) {
            if (err)
            {
                console.log('File download failed. Error:')
                console.log(err);
                setCloudFile("");
            }
            else
            {
                console.log('File download complete')
                var decodedBody = new TextDecoder().decode(data.Body);

                var fileJson = JSON.parse(decodedBody);
                var isChecked = fileJson["Parameters"]["AdBanner"]

                var inputElementsRailways = document.getElementsByClassName('armoredCheckbox');
                console.log("inputElements = " + inputElementsRailways.length);
                for(var i=0; inputElementsRailways[i]; ++i){
                    console.log("inputElements i = " + i);
                    var inputElement = inputElementsRailways[i] as HTMLInputElement;
                    inputElement.checked = isChecked;
                }

                setIsArmoredChecked(isChecked);
                console.log("isArmoredTrainCheckedOnStart = " + isArmoredChecked);

                setCloudFile(decodedBody);
            }
        });
    }

    function UploadFile(fileName:string, fileBody:string){
        console.log("Start upload file: " + fileName)

        var params = {
            Bucket: bucketName,
            Key: fileName,
            Body: fileBody,
        };

        s3.putObject(params, function(err: string, data:any) {
            if (err)
            {
                console.log('File upload failed. Error: ')
                console.log(err);
            }
            else
            {
                console.log('File upload complete');
            }
        });
    }

    AwsInit();

    DownloadFile("RemoteConfig.json");

    // if (cloudFile != ``){
    //     var fileJson = JSON.parse(cloudFile);
    //     console.log("fileJson = " + fileJson);
    // }
    // console.log("file = " + cloudFile);

    // var isArmoredTrainCheckedOnStart:boolean = false;

    // if (cloudFile != ``){
    //     var fileJson = JSON.parse(cloudFile);
    //     var isChecked = fileJson["Parameters"]["AdBanner"]
    //     setIsArmoredChecked(isChecked);
    //     console.log("isArmoredTrainCheckedOnStart = " + isArmoredChecked);
    // }


    return(
        <div className="bannerMainContainer">
            <div className="info">
                <h1>Состояние баннеров</h1>

                <br/>
                {/*<br/>*/}

                <div className="bannerMainDiv">
                    {/*<h4>Баннер в "Сортировочной станции"</h4>*/}
                    <br/>
                    <label htmlFor="railwaysId">Баннер в игре "Сортировочная станция" - </label>
                    <input id="railwaysId" className="railwaysCheckbox" type="checkbox" defaultChecked={isRailwaysCheckedOnStart}/>
                </div>

                {/*<br/>*/}
                <br/>

                <div className="bannerMainDiv">
                    {/*<h4>Баннер в "Бронепоезде"</h4>*/}
                    <br/>
                    <label htmlFor="aromredId">Баннер в игре "Бронепоезд" - </label>
                    <input id="aromredId" className="armoredCheckbox" type="checkbox" defaultChecked={isArmoredChecked}/>
                </div>
            </div>

            <br/>
            <br/>

            <button onClick={() => saveAndDeployChanges()}>Сохранить и применить</button>
        </div>
    )
}

export default Banner